import { isNumber, isString } from 'class-validator';

export const SELF_CHECKIN_RADIUS_LIMIT_MILES = 1;

export const GATE_MANAGEMENT_SALES_URL =
  'https://lp.opendock.com/gate-management?utm_source=opendockapp&utm_medium=cta&utm_campaign=od-gate-management-warehouse-opendock-q4-24&utm_content=appt-details';

export const GATE_MANAGEMENT_USER_EMAIL = 'gatemanagement@example.com';

export const SELF_CHECKIN_LEAD_TIME_MINUTES = 60 * 24;

// Countries GateManagementCheckInSmsSettings' check-in SMS flow supports. Shared with
// apps/helios/src/modules/settings/warehouse/features/gate_management/SmsPanel.vue, which
// gates its whole panel wrapper on this same list (in addition to
// GateManagementCheckInSmsSettings' own `enable-check-in-sms-template` flag and
// isGateManagementEnabled check) so a warehouse outside these countries never gets a
// clickable "SMS Message to drivers" row that opens onto nothing - see
// GateManagementCheckInSmsSettings.vue:92 for the three-condition gate this list is one
// third of. Keep both usages in sync with this single list.
// Typed `readonly string[]` (not `as const`, which would narrow the element type to the
// `"USA" | "CAN"` literal union and break both consumers' `.includes(warehouse?.country ??
// 'USA')` calls - `country` is a plain `string`, not one of those two literals, at the type
// level). This still prevents either consumer from mutating the shared list (`.push`,
// index-assignment, etc all fail to compile against a ReadonlyArray).
export const SMS_COUNTRIES: readonly string[] = ['USA', 'CAN'];

export function milesToMeters(miles: number): number {
  if (isNumber(miles) || isString(miles)) {
    return Number(miles) * 1609.34;
  }
  throw new Error(`Invalid miles ${miles}`);
}
export interface ICheckInPrimaryField {
  label: string;
  key: string;
  type: string;
  description: string;
  requiredForDrivers: boolean;
  requiredForWarehouse: boolean;
}

export const CheckInPrimaryFields: ICheckInPrimaryField[] = [
  {
    label: 'Asset Type',
    key: 'assetType',
    type: 'singleSelect',
    description: '',
    requiredForDrivers: true,
    requiredForWarehouse: true
  },
  {
    label: 'Asset ID',
    key: 'assetId',
    type: 'number',
    description: '',
    requiredForDrivers: true,
    requiredForWarehouse: true
  },
  {
    label: "Driver's Phone Number",
    key: 'driversPhoneNumber',
    type: 'number',
    description: '',
    requiredForDrivers: true,
    requiredForWarehouse: true
  },
  {
    label: 'Carrier Company',
    key: 'carrierCompany',
    type: 'singleSelect',
    description: '',
    requiredForDrivers: true,
    requiredForWarehouse: true
  },
  {
    label: 'Reference Number',
    key: 'referenceNumber',
    type: 'text',
    description: '',
    requiredForDrivers: false,
    requiredForWarehouse: false
  },
  {
    label: 'License Plate',
    key: 'licensePlate',
    type: 'text',
    description: '',
    requiredForDrivers: false,
    requiredForWarehouse: false
  },
  {
    label: 'DOT Number',
    key: 'dotNumber',
    type: 'text',
    description: '',
    requiredForDrivers: false,
    requiredForWarehouse: false
  },
  {
    label: 'Driver Notes',
    key: 'driverNotes',
    type: 'text',
    description: '',
    requiredForDrivers: false,
    requiredForWarehouse: false
  }
];
